import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import { Container } from 'reactstrap';
import Table from './Table/Table';
import UserModal from './UserModal/UserModal';
import PasswordModal from './PasswordModal/PasswordModal';
import axiosInstance from '@src/axios-instance';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';

class AdminUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      loading: false,
      list: [],
      modalActive: false,
      modalPasswordActive: false,
      createError: false,
      passwordError: false,
      sort: 'name',
      direction: 'ASC',
      entity: {}
    };
  }

  toggle = (modalType, entity) => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType],
      createModal: false,
      entity: entity
    }));
  };

  loadUserList = getData => {
    const requestData = {
      sort:
        getData !== undefined && getData.sort !== undefined
          ? getData.sort
          : this.state.sort,
      direction:
        getData !== undefined && getData.direction !== undefined
          ? getData.direction
          : this.state.direction
    };
    axiosInstance()
      .get('/users.json', { params: requestData })
      .then(response => {
        this.setState({
          loaded: true,
          list: response.data.list,
          sort: response.data.sort,
          direction: response.data.direction
        });
      });
  };
  componentDidMount = () => {
    document.getElementById('root').click();

    this.loadUserList();
  };

  changePassword = postData => {
    axiosInstance()
      .put(`/users/${this.state.entity.id}.json`, postData)
      .then(response => {
        this.setState({
          modalPasswordActive: false,
          passwordError: false
        });
        this.loadUserList();
      })
      .catch(err => {
        this.setState({
          passwordError: err.response.data.message
        });
      });
  };

  saveUser = postData => {
    this.setState({ loading: true });
    if (this.state.entity.id !== undefined) {
      axiosInstance()
        .put(`/users/${this.state.entity.id}.json`, postData)
        .then(response => {
          this.setState({
            modalActive: false,
            createError: false
          });
          this.loadUserList();
          this.setState({ loading: false });
        })
        .catch(err => {
          this.setState({
            createError: err.response.data.message,
            loading: false
          });
        });
    } else {
      axiosInstance()
        .post('/users.json', postData)
        .then(response => {
          this.setState({
            modalActive: false,
            createError: false
          });
          this.loadUserList();
          this.setState({ loading: false });
        })
        .catch(err => {
          this.setState({
            createError: err.response.data.message,
            loading: false
          });
        });
    }
  };

  render = () => {
    return (
      <Container>
        <Helmet>
          <title>NXT Insurance Hub | Users</title>
        </Helmet>
        {this.state.loaded && (
          <div id={'setting-users'}>
            {this.state.loading && (
              <ProgressBox text={'Loading ...'} loader={'blue-background'} />
            )}
            <h3>
              Users
              <button
                className={'btn btn-primary px-3 float-right'}
                onClick={() => this.toggle('modalActive', {})}
              >
                Create New User
              </button>
            </h3>

            <Table
              entities={this.state.list}
              onEntityClick={entity => this.toggle('modalActive', entity)}
              onChangePassword={entity =>
                this.toggle('modalPasswordActive', entity)
              }
              {...this.state}
              paginationFunc={this.loadUserList}
            />
            {this.state.modalActive && (
              <UserModal
                isActive={this.state.modalActive}
                toggle={() => this.toggle('modalActive')}
                entity={this.state.entity}
                onSubmit={postData => this.saveUser(postData)}
                error={this.state.createError}
              />
            )}

            {this.state.modalPasswordActive && (
              <PasswordModal
                isActive={this.state.modalPasswordActive}
                toggle={entity => this.toggle('modalPasswordActive', entity)}
                entity={this.state.entity}
                onSubmit={postData => this.changePassword(postData)}
                error={this.state.passwordError}
              />
            )}
          </div>
        )}
      </Container>
    );
  };
}
export default AdminUsers;
